export default __webpack_public_path__ + "images/52f83417f1cd74d56e7644b79a039508.svg";